
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("hSA7G", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.5cd6107b.js.map
